import { baseApi } from '@app/store/index.api';
import { DownloadResponse } from '@shared/types/download';

import {
  IOrderBulkResendCallbackQuery,
  IOrderBulkResendCallbackResponse,
  IOrderApproveQuery,
  IOrderApproveARSQuery,
  IOrderApproveKRWQuery,
  IOrderApproveResponse,
  IOrderCreateManualQuery,
  IOrderCreateManualResponse,
  IOrderExportQuery,
  IOrderFailQuery,
  IOrderFailResponse,
} from '../model/types';

const ordersApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    approveOrder: builder.mutation<IOrderApproveResponse, IOrderApproveQuery>({
      query: ({ id, actual_amount, customer_transaction_id, reason }) => {
        return {
          url: `/orders/deposits/${id}/approve-manually`,
          method: 'POST',
          body: { actual_amount, customer_transaction_id, reason },
        };
      },
    }),
    approveOrderARS: builder.mutation<IOrderApproveResponse, IOrderApproveARSQuery>({
      query: ({ id, actual_amount, cuit_cuil, coelsa_id, reason }) => {
        return {
          url: `/orders/deposits/${id}/approve-manually-ars`,
          method: 'POST',
          body: { actual_amount, cuit_cuil, coelsa_id, reason },
        };
      },
    }),
    approveOrderKRW: builder.mutation<IOrderApproveResponse, IOrderApproveKRWQuery>({
      query: ({ id, actual_amount, account_name, account_number, bank_name, reason }) => {
        return {
          url: `/orders/deposits/${id}/approve-manually-sk`,
          method: 'POST',
          body: { actual_amount, account_name, account_number, bank_name, reason },
        };
      },
    }),
    failOrder: builder.mutation<IOrderFailResponse, IOrderFailQuery>({
      query: ({ type, id, reason }) => {
        return {
          url: `/orders/${type}s/${id}/fail-manually`,
          method: 'POST',
          body: { reason },
        };
      },
    }),
    createManualOrder: builder.mutation<IOrderCreateManualResponse, IOrderCreateManualQuery>({
      query: body => {
        return {
          url: '/orders/deposits/manual',
          method: 'POST',
          body,
        };
      },
    }),
    bulkResendCallbackOrder: builder.mutation<
      IOrderBulkResendCallbackResponse,
      IOrderBulkResendCallbackQuery
    >({
      query: ({ ids }) => {
        return {
          url: `/orders/statuses/send-bulk`,
          method: 'POST',
          body: { ids },
        };
      },
    }),
    ordersExportsDownload: builder.mutation<
      DownloadResponse,
      IOrderExportQuery & { type: 'deposits' | 'withdrawals' }
    >({
      query: ({ type, ...query }) => {
        return {
          url: `/orders/${type}/exports/download`,
          method: 'POST',
          body: query,
          responseHandler: async response => {
            return await response.json();
          },
        };
      },
    }),
  }),
});

export const {
  useBulkResendCallbackOrderMutation,
  useApproveOrderMutation,
  useApproveOrderARSMutation,
  useApproveOrderKRWMutation,
  useFailOrderMutation,
  useCreateManualOrderMutation,
  useOrdersExportsDownloadMutation,
} = ordersApi;
